module.exports = __webpack_public_path__ + "img/xianhuadousha.83347cf7.jpg";